/**
 * Attempt to parse a compound condition string into structured conditions.
 * Only conservative extraction: every "+"-separated (or "e"/"and") token must
 * match a single "<param> <op> <number>" pattern. Otherwise returns null.
 */
const PARAM_MAP = [
  ["pa_sys",   /^(?:PAS|PA\s*sist(?:olica)?|Pressione\s+sistolica)$/i],
  ["pa_dia",   /^(?:PAD|PA\s*diast(?:olica)?|Pressione\s+diastolica)$/i],
  ["fc",       /^(?:FC|Frequenza\s+cardiaca)$/i],
  ["fr",       /^(?:FR|Frequenza\s+respiratoria)$/i],
  ["spo2",     /^(?:SpO[₂2]|SatO2|Saturazione)$/i],
  ["temp",     /^(?:Temperatura|Temp)$/i],
  ["glicemia", /^Glicemia$/i],
  ["hb",       /^(?:Hb|Emoglobina)$/i],
  ["gcs",      /^(?:GCS|Glasgow)$/i],
  ["nrs",      /^(?:NRS|Dolore)$/i],
];

const OP_NORMALIZE = { "≥": "≥", ">=": "≥", "≤": "≤", "<=": "≤", ">": ">", "<": "<", "=": "=", "≠": "!=", "!=": "!=" };

function normalizeParam(token) {
  const t = token.trim();
  for (const [key, rx] of PARAM_MAP) if (rx.test(t)) return key;
  return null;
}

function parseSingleCondition(text) {
  // <param> <op> <num> [unit]
  const rx = /^\s*(.+?)\s*(≥|≤|>=|<=|>|<|≠|!=|=)\s*(\d+(?:[.,]\d+)?)\s*(?:°C|mmHg|%|mg\/dL|g\/dL|bpm|atti\/min|\/min)?\s*$/i;
  const m = text.match(rx);
  if (!m) return null;
  const parameter = normalizeParam(m[1]);
  if (!parameter) return null;
  return {
    parameter,
    operator: OP_NORMALIZE[m[2]] || m[2],
    threshold: Number(String(m[3]).replace(",", ".")),
    threshold_max: null,
  };
}

/**
 * Try to split by "+" (with surrounding spaces) or " e ", parse each token.
 * All tokens must succeed for a positive result.
 */
export function tryParseCompound(text) {
  if (!text) return null;
  const parts = text.split(/\s*(?:\+|\bE\b|\band\b|\be\b)\s*/i)
    .map((s) => s.trim())
    .filter(Boolean);
  if (parts.length < 2) return null;
  const conds = parts.map(parseSingleCondition);
  if (conds.some((c) => !c)) return null;
  return { conditions: conds, combinator: "AND" };
}
